import { render, staticRenderFns } from "./ApplicationBriefDescription.vue?vue&type=template&id=36c20074&"
import script from "./ApplicationBriefDescription.vue?vue&type=script&lang=ts&"
export * from "./ApplicationBriefDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports